import { ReservationTimeState } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import ReservationConfirmationAction from './ReservationConfirmationAction';
import ReservationCheckOutAction from './ReservationCheckOutAction';
import ReservationSecondaryActions from './ReservationSecondaryActions';
import { ReservationCheckInActionWithState } from './ReservationCheckInActionWithState';

interface OwnProps {
    reservationId: string;
    timeState: ReservationTimeState;
    onUpdate: () => void;
}

export const ReservationPrimaryAction = ({ reservationId, timeState, onUpdate }: OwnProps) => {
    switch (timeState) {
        case ReservationTimeState.ToBeCheckedIn:
        case ReservationTimeState.CheckInMissed:
            return (
                <Stack itemAlignment="center" alignment="end" spacing="100">
                    <ReservationSecondaryActions reservationId={reservationId} />
                    <ReservationCheckInActionWithState
                        variant="primary"
                        reservationId={reservationId}
                        onUpdate={onUpdate}
                        withCheckInButton
                    />
                </Stack>
            );

        case ReservationTimeState.CheckedIn:
            return (
                <Stack itemAlignment="center" alignment="end" spacing="100">
                    <ReservationSecondaryActions reservationId={reservationId} withKeyCutter />
                </Stack>
            );

        case ReservationTimeState.ToBeConfirmed:
        case ReservationTimeState.ConfirmationMissed:
            return <ReservationConfirmationAction reservationId={reservationId} onUpdate={onUpdate} />;

        case ReservationTimeState.ToBeCheckedOut:
        case ReservationTimeState.CheckOutMissed:
            return <ReservationCheckOutAction reservationId={reservationId} onUpdate={onUpdate} />;

        default:
            return null;
    }
};
